
/* Selectors */
//searchFilters
import isEmpty from 'lodash/isEmpty';

import { getBundle, getEventsCountBasedOnCategory, getSelectedEvent } from "./EventSelectors";
import { createSelector } from 'reselect';

export const getActiveLinkFilters = state => state.activeLinkFilters;
export const getVenueSearchFilters = state => state.venue.venueSearchFilters;
export const getVenueSearchParams = state => state.venue.venueSearchParams;
export const getSortingOptions = state => state.venue.sortFilters;
export const getAppliedFilters = state => state.venue.appliedFilters;
export const getVenueLoadingState = state => state.venue.isFetchingVenues;
export const getFiltersLoadedState = state => state.venue.isBaseFiltersLoaded;
export const getVenueSearchValidatorUpdatingState = state => state.venue.isUpdatingVenueSearchValidators;

export const getNewEventPlanModalState = state => state.venue.isNewEventFormVisible;
//searchHeader
export const getPageTags = state => state.venue.pagetags;
export const getCity = state => state.venue.city;

//MyEventPopup
export const getVenues = state => state.venue.list;
export const getTotalCount = state => state.venue.totalCount;
export const getPageNum = state => parseInt(state.venue.pageNum);
export const getPageSize = state => parseInt(state.venue.pageSize);
// export const getPageStart = (state) => {
//     let pageNum = getPageNum(state);
//     let pageSize = getPageSize(state);
//     let totalCount = getTotalCount(state);
//     return (totalCount > 0) ? (pageNum - 1)* pageSize + 1 : 0;
// }
// export const getShortlistedState = (state) => {
//     let venueid = getVenueId(state);
//     let bundle = getBundle(state);
//     () => {bundle && bundle.venueList ? bundle.venueList.filter(({ userReject, uid }) => !userReject && uid && uid._id === venueid).length > 0 : false}
// }
// export const getPageStart = createSelector(
//     [getPageNum, getPageSize, getTotalCount],
//     (pageNum, pageSize, totalCount) => (totalCount > 0) ? (pageNum - 1) * pageSize + 1 : 0);
// export const getPageEnd = createSelector(
//     [getPageNum, getPageSize, getTotalCount],
//     (pageNum, pageSize, totalCount) => totalCount > 0 ? ((totalCount - (pageNum - 1) * pageSize) < pageSize) ? totalCount : pageNum * pageSize : 0);
// export const getTotalPageCount = createSelector(
//     [getPageSize, getTotalCount],
//     (pageSize, totalCount) => totalCount > 0 ? Math.ceil(totalCount / pageSize) : 0);
export const getPageStart = state => {
    let pageNum = getPageNum(state);
    let pageSize = getPageSize(state);
    let totalCount = getTotalCount(state);
    return (totalCount > 0) ? (pageNum - 1) * pageSize + 1 : 0};
export const getPageEnd = (state) =>{
    let pageNum = getPageNum(state);
    let pageSize = getPageSize(state);
    let totalCount = getTotalCount(state);
    return (totalCount > 0 ? ((totalCount - (pageNum - 1) * pageSize) < pageSize) ? totalCount : pageNum * pageSize : 0)};
export const getTotalPageCount = (state) => {
    let pageSize = getPageSize(state);
    let totalCount = getTotalCount(state);
    return (totalCount > 0 ? Math.ceil(totalCount / pageSize) : 0)};

export const getShortlistedState = (state) => {
    let venueid = getVenueId(state);
    let bundle = getBundle(state);
    return bundle && bundle.venueList ? bundle.venueList.filter(({ userReject, uid }) => !userReject && uid && (uid === venueid)).length > 0 : false
}

export const isShowLoder = state => (parseInt(state.venue.pageNum) * parseInt(state.venue.pageSize)) < (state.venue.totalCount + 1);
export const getEventMadeState = state => state.venue.isEventMade;
export const getSelectedVenues = state => state.venue.selectedVenue;
// export const getRecoVenues = state => state.venue.recoVenues;

//VenuePage
export const getReviewModalVisibleState = state => state.venue.isReviewModalVisible;
export const getReviewSuccessModalState = state => state.venue.isReviewSuccessModalVisible;
export const getReviewListModalVisibleState = state => state.venue.isReviewListModalVisible;
export const getVenuePage = state => state.venue.venue;
export const getMainVenuePage = state => state.venue.mainPageVenue;
export const getAssetVenuePage = state => state.venue.assetPageVenue;
export const getPackageVenuePage = state => state.venue.packagePageVenue;
export const getReviewVenuePage = state => state.venue.reviewPageVenue;
export const getSimilarVenues = state => state.venue.similarVenues ? state.venue.similarVenues : [];
export const getSimilarVenuesLoadingState = state => state.venue.isFetchingSimilarVenues;
export const getVenueId = state => !isEmpty(state.venue.venue) ? state.venue.venue._id : null;
export const getVenuePackages = state => state.venue.packages;
export const getVenueImages = state => state.venue.images;
export const getVenueMenus = state => state.venue.menus;
export const getVenuePageLoadingState = state => state.venue.isLoadingVenuePage;
export const getVenueReview = state => state.venue.review;
export const getReviewId = state => !isEmpty(state.venue.venue) ? state.venue.venue.review : null;
export const getVenueContactId = state => !isEmpty(state.venue.venue) ? state.venue.venue.venuecontact : null;
export const getVenueComments = state => state.venue.comments ? state.venue.comments : [];
export const getReviewPageNum = state => state.venue.reviewPageNum;
export const getTotalCommentCount = state => state.venue.totalCommentsCount ? state.venue.totalCommentsCount : 0;
export const getUserPreviousCommentState = state => state.venue.userHasCommented;
export const getUserComment = state => state.venue.userComment;
export const getVenueRealEvents = state => state.venue.realevents;
export const getUserPostingState = state => state.venue.isPostingUserComment;
export const getUserEditingState = state => state.venue.isEditingUserComment;
export const getUserUpdatingState = state => state.venue.isUpdatingUserComment;
export const getUserDeletingState = state => state.venue.isDeletingUserComment;
export const getVenuePageCommentsLoadingState = state => state.venue.isFetchingComments;
export const getVenueShortlistingState = state => state.venue.isShortlistingVenue;
export const getShortlistingVenueId = state => state.venue.shortlistingVenueId
//  export const getCommentListState = (state) => {
//          let comments = getVenueComments(state);
//          let totalCommentsCount = getTotalCommentCount(state);
//          () => (comments.length >= totalCommentsCount)
//      };
// export const getCommentListState = (state) => {
//     let totalComments = getTotalCommentCount(state);
//     let comments = getVenueComments(state);
//     if(comments.length === totalComments){
//         return true
//     }
// }
export const getTotalReviewCount = state => state.venue.totalReviewCount ? state.venue.totalReviewCount : 0;
export const getVenueExpertReview = state => state.venue.venueExpertReview;
export const getVenueFaqs = state => state.venue.venueFaqs;
export const getVenueQas = state => state.venue.venueQas;
export const getVenueSpaces = state => state.venue.venueSpaces;
export const getVenueExpert = state => state.venue.venueExpert;
export const getSublinkPage = state => state.venue.sublinkPageData
export const getUserAskedQuestionList = state => state.venue.userAskedQuestionList;
export const getQnAList = state => state.venue.qnaList;
export const getMoreQnaList = state => state.venue.moreQnaList;
export const getQnaPageNum = state => state.venue.qnaPageNum;
export const getVenuePageMoreQnaLoadingState = state => state.venue.isFetchingMoreQna;
export const getVenueMoreQna = state => state.venue.qnaList ? state.venue.qnaList : [];
export const getQnACount = state => state.venue.qnaCount;
export const getMoreQnaListState = (state) => {
    let qnaList =getVenueMoreQna(state);
    let qnaCount = getQnACount(state);
    () => (qnaList.length >= qnaCount);
}
export const getPopularVenues = state => state.venue.popularVenues ? state.venue.popularVenues : [];
export const getQnASuggestionList = state => state.venue.qnASuggestionList;
export const getIsUserQuestionPosted = state => state.venue.isUserQuestionPosted;
export const getSuccessModalVisibleState = state => state.venue.isSuccessModalVisible;
export const isDeletingUserQuestion = state => state.venue.isDeletingUserQuestion
export const getProcessingDeleteQuestionStatus = state => state.venue.processingDeleteQuestionRequest;
export const getCommentMap = state => state.venue.commentMap;
//ReviewsPage
export const getUserProfileCommentSavingState = state => state.venue.isSavingUserProfileComment;
export const getUserReviews = state => state.venue.userReviews;
export const getUserReviewsPageLoadingState = state => state.venue.isLoadingUserReviewsPage;
export const getCurrentUserReviewPage = state => state.venue.currentUserReviewPage;
export const getUserReviewCount = state => state.venue.userReviewCount;
export const getUserReviewLoadingState = state => state.venue.isFetchingUserReviews;
export const getQnAVenueId = state => state.venue.qaPageVenue && state.venue.qaPageVenue._id ? state.venue.qaPageVenue._id : null;
export const getQuestionAlreadyExist = state => state.venue.questionAlreadyExistVisiblity;

//ReviewReport
export const getReportedComment = state => state.venue.reportedComment;
export const getReviewReportLoadingState = state => state.venue.isLoadingReviewReport;

//Seolink Page
export const getSeoLinkLoadingState = state => state.venue.isFetchingSeoLink;
export const getSeoLink = state => state.venue.seolink;
export const getSeoLinkTags = state => !isEmpty(state.venue.seolink) ? state.venue.seolink.tags : '';
export const getSeoLinkKeyword = state => !isEmpty(state.venue.seolink) ? state.venue.seolink.keyword : '';
export const getSeoLinkQuery = state => !isEmpty(state.venue.seolink) ? state.venue.seolink.query : '';
export const getSeoLinkCity = state => !isEmpty(state.venue.seolink) ? state.venue.seolink.city : '';

// search link
export const getSearchValidators = state => state.venue.searchValidators ? state.venue.searchValidators : {};
export const getSearchLinkLoadingState = state => state.venue.isFetchingSearchLink;
export const getSearchLink = state => !isEmpty(state.venue.searchlink) ? state.venue.searchlink : null;
export const getSearchLinkQuery = state => !isEmpty(state.venue.searchlink) ? state.venue.searchlink.queryString : '';

export const getCompareVenues = state => state.venue.compareVenues ? state.venue.compareVenues : [];
export const getCompareVenuesLoadingState = state => state.venue.isFetchingCompareVenues;
export const getVenueDataLoadingState = state => state.venue.isLoadingVenueData;
export const getCompareVenue = state => state.venue.compareVenue;


export const getAddAnswerModalVisibleState = state => state.venue.addAnswerModalVisibleState;
export const getAddAnswerModalContextState = state => state.venue.answerModalContextState;


export const getIsVenueGalleryOpen = state => state.venue.isVenueGalleryOpen;
export const getClickedVenueSearchPage = state => state.venue.clickedVenueSearchPage;
export const getClickedVenueAssets = state => state.venue.clickedVenueAssets;
export const getIsFetchingVenueAssets = state => state.venue.isFetchingVenueAssets;
export const getClickedVenue = state => state.venue.clickedVenue;
export const getIsUpadateQnaPage = state => state.venue.updateQnaPage;
export const getVenueTourModalVisibleState = state => state.venue.isVenueTourModalVisible

export const getStateForceHideSayaBanner = state => state.venue.isHideSayaDateBanner
export const getIsSayaDateState = state => state.venue.isSayaDate

export const getReviewSuccessScreenShow = state => state.venue.isShowSuccessScreen
export const getReviewTicketData = state => state.venue.reviewticketdata



export const getSayaDateBannerVisibleState = createSelector(
    [getStateForceHideSayaBanner, getIsSayaDateState,getEventsCountBasedOnCategory,getSelectedEvent],
    (isHideSayaDateBanner, isSayaDate,eventsCount,event) => {
        if (isHideSayaDateBanner) {
            return false;
        }
        else if (isSayaDate && event.event_name=="Wedding") {
            return true;
        }
        else if (eventsCount > 10 && event.event_name=="Wedding"){
            return true
        }
        else {
            return false;
        }
    }
);


